import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MaintenanceService } from '@shared/services/maintenance.service';

@Component({
  selector: 'lib-maintenance-page',
  templateUrl: 'maintenance-page.component.html',
  styleUrls: ['maintenance-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaintenancePageComponent {
  public readonly maintenanceService = inject(MaintenanceService);

  public tryAgain() {
    window.location.reload();
  }
}
